import React from "react";
import "../styles/FAQs.css";

const FAQs = () => {
  return (
    <div className="faqs-container">
      <h1>Frequently Asked Questions</h1>
      <h3>❓ How do I apply for jobs?</h3>
      <p>Simply browse jobs and click "Apply Now" to submit your application.</p>

      <h3>❓ Is this platform free?</h3>
      <p>Yes! HirePro is completely free for job seekers.</p>

      <h3>❓ How can I get resume tips?</h3>
      <p>Visit our <a href="/resume-tips">Resume Tips</a> section.</p>
    </div>
  );
};

export default FAQs;
